/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import firebase from './../firebase/firebase';

const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
    }
    else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp                 = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited    = state.starredPages.slice(0, 10)
    state.starredPages           = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay       = val },
  UPDATE_PRIMARY_COLOR(state, val)   { state.themePrimaryColor = val },
  UPDATE_THEME(state, val)           { state.theme             = val },
  UPDATE_WINDOW_WIDTH(state, width)  { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY = val },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  IS_NEW_USER_ACCOUNT(state, payload) {
    state.isNewUser = payload
  },
  
  UPDATE_COMPANY_INFO(state, payload) {
    let company = state.AppActiveCompany
    state.AppActiveCompany = { ...company, ...payload }
  },

  UPDATE_COMPANY_FISCAL(state, payload) {
    let fiscal = state.AppActiveCompany.fiscal
    state.AppActiveCompany.fiscal = { ...fiscal, ...payload }
  },  

  UPDATE_COMPANY_ADDRESS(state, payload) {
    let endereco = state.AppActiveCompany.fiscal.endereco
    state.AppActiveCompany.fiscal.endereco = {...endereco, ...payload}
  },

  UPDATE_COMPANY_ALLOW_ASK_FOR_HELP(state, payload) {
    state.AppActiveCompany.allowAskForHelp = payload
  },

  UPDATE_COMPANY_ID(state, payload) {
    state.AppActiveCompany.id = payload;
    state.AppActiveUser.companyId = payload
  },

  UPDATE_COMPANY_RAZAO_SOCIAL(state, payload) {
    state.AppActiveCompany.fiscal.razaoSocial = payload
  },

  UPDATE_USER_INFO(state, payload) {
    let AppActiveUser = state.AppActiveUser
    state.AppActiveUser = {...AppActiveUser, ...payload}
  },

  SET_USER (state, user) {
    state.AppActiveUser = user;
  },
  SET_PAGE_INTENT_AFTER_LOGIN (state, route) {
    state.pageIntent = Object.freeze(route);
  },

  UPDATE_USER_NOTIFY_ORDERS (state, payload) {
    state.AppActiveUser.notify.newOrder = payload
  },

  UPDATE_USER_NOTIFY_BILL (state, payload) {
    state.AppActiveUser.notify.newBill = payload
  },

  UPDATE_USER_NOTIFY_WAITER (state, payload) {
    state.AppActiveUser.notify.waiter = payload
  },

  UPDATE_USER_NAME(state, payload) {
    state.AppActiveUser.name = payload
  },

  UPDATE_USER_PHOTO(state, payload) {
    state.AppActiveUser.photoURL = payload
  },

  UPDATE_USER_CPF(state, payload) {
    state.AppActiveUser.cpf = payload
  },

  UPDATE_USER_PHONE(state, payload) {
    state.AppActiveUser.phone = payload
  },

  UPDATE_USER_COMANY_ID(state, payload) {
    state.AppActiveUser.companyId = payload
  },
  
  FLASH_MESSAGE(state, payload) {
    state.system.flashMessage = payload
  },
  
  LOGOUT_USER(state) {
    state.AppActiveUser = null;
    state.AppActiveCompany = {}
    state.productTypes = []

    firebase.auth().signOut()
  },

  SET_SESSION_LOADED(state, loaded) {
    state.isLoadingSession = !loaded;
  },

  setError(state, error) {
    state.error = error;
  },
}

export default mutations

